const Loading = () => (
    <div className="loading-container">
        <img src={`${process.env.PUBLIC_URL}/img/ui/falling.webp`} alt="" />
        <h1>LOADING...</h1>
    </div>
)

export default Loading;